import React from 'react';
//material
import {Container, withStyles, Grid} from '@material-ui/core';
//styles
import styles from './competition-styles';
//components
import CompetitionCard from '../../../components/matchplay/competition-card';
import DetailsCard from '../../../components/matchplay/details-card';
import NextMatch from '../../../components/matchplay/next-match-card';
import ViewOpponent from '../../../components/matchplay/view-opponent/view-opponent-view';
import TeamPlayer from '../../../components/team-player';
import ResultCard from '../../../components/matchplay/results-card';
import BracketCard from '../../../components/matchplay/bracket-card';
import EnterResults from '../../../components/matchplay/enter-results';

const CompetitionView = (props) => {
  const {
    classes,
    isLoading,
    details,
    rounds,
    results,
    handleSetViewOpponent,
    viewOpponent,
    opponent,
    bracketMatches,
    viewEnterResults,
    handleSetViewEnterResults,
    resultsSubmissionLoading,
    handleResultsSubmission
  } = props;

  return (
    <div>
      <div style={{backgroundImage: `url(${!isLoading ? details.competitionImageUrl : ''})`}} className={classes.heroImage}/>

      <Container maxWidth={'md'} className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CompetitionCard
              isLoading={isLoading}
              competition={details}
              handleSetViewEnterResults={handleSetViewEnterResults}/>
          </Grid>

          <Grid item xs={12} md={6}>
            <DetailsCard
              isLoading={isLoading}
              rounds={rounds}/>
          </Grid>

          <Grid item xs={12} md={6}>
            <NextMatch
              details={details}
              handleSetViewOpponent={handleSetViewOpponent}
              isLoading={isLoading}
              results={results}
              opponent={opponent}
              isSingles={details && !details.additionalPlayer}/>
          </Grid>

          <Grid item xs={12} md={6}>
            <TeamPlayer
              isLeadPlayer
              player={!isLoading ? details.leadPlayer : {}}
              isLoading={isLoading}
              displayAvatar
              emailLink/>
          </Grid>

          {
            !isLoading && details.additionalPlayer &&
              <Grid item xs={12} md={6}>
                <TeamPlayer
                  player={!isLoading ? details.additionalPlayer : {}}
                  isLoading={isLoading}
                  displayAvatar
                  emailLink/>
              </Grid>
          }

          {
            (!isLoading && details.bracketId && !details.hideBracketsInMatchplay && details.isDrawn) &&
            <Grid item xs={12}>
              <BracketCard
                isLoading={isLoading}
                details={details}
                bracketMatches={bracketMatches}
                rounds={rounds}/>
            </Grid>
          }

          {
            !isLoading && results.length > 0 &&
            <Grid item xs={12}>
              <ResultCard
                rounds={rounds}
                results={results}
                isLoading={isLoading}/>
            </Grid>
          }
        </Grid>
      </Container>

      {
        viewOpponent &&
        <ViewOpponent
          viewOpponent={viewOpponent}
          handleSetViewOpponent={handleSetViewOpponent}
          opponent={opponent}/>
      }

      {
        viewEnterResults &&
          <EnterResults
            viewEnterResults={viewEnterResults}
            handleShowEnterResults={handleSetViewEnterResults}
            details={details}
            opponent={opponent}
            resultsSubmissionLoading={resultsSubmissionLoading}
            handleResultsSubmission={handleResultsSubmission}/>
      }
    </div>
  );
};

export default withStyles(styles) (CompetitionView);
